export const SITES_GRID_NAME = 'SitesGrid';

export const SITE_STATUS__PENDING = 'PENDING';
export const SITE_STATUS__ACTIVE = 'ACTIVE';
export const SITE_STATUS__SUSPENDED = 'SUSPENDED';
export const SITE_STATUS__DELETED = 'DELETED';
export const SITE_STATUS__DELETED_WITH_WEBMASTER = 'DELETED_WITH_WEBMASTER';

export const siteStatuses = [
  SITE_STATUS__PENDING,
  SITE_STATUS__ACTIVE,
  SITE_STATUS__SUSPENDED,
  SITE_STATUS__DELETED,
  SITE_STATUS__DELETED_WITH_WEBMASTER,
];

export const siteStatusLangKeys = {
  [SITE_STATUS__PENDING]: 'msg.site.status.pending',
  [SITE_STATUS__ACTIVE]: 'msg.site.status.active',
  [SITE_STATUS__SUSPENDED]: 'msg.site.status.suspended',
  [SITE_STATUS__DELETED]: 'msg.site.status.deleted',
  [SITE_STATUS__DELETED_WITH_WEBMASTER]: 'msg.site.status.deleted-with-webmaster',
};
